import { z } from 'zod';
export const GrowthStageSchema = z.enum([
    'seedling',
    'vegetative',
    'flowering',
    'fruiting',
    'harvest',
]);
export const ConfirmGrowthBodySchema = z.object({
    plantHeight: z.number().positive().nullable().optional(),
    leafCount: z.number().int().nonnegative().nullable().optional(),
    fruitCount: z.number().int().nonnegative().nullable().optional(),
    growthStage: GrowthStageSchema.nullable().optional(),
    leafArea: z.number().positive().nullable().optional(),
    healthScore: z.number().int().min(1).max(5).nullable().optional(),
    healthNotes: z.string().max(1000).nullable().optional(),
    cropType: z.string().min(1).optional(),
});
export const CropConfigBodySchema = z.object({
    tempMin: z.number().nullable().optional(),
    tempMax: z.number().nullable().optional(),
    humidityMin: z.number().nullable().optional(),
    humidityMax: z.number().nullable().optional(),
    co2Min: z.number().int().nonnegative().nullable().optional(),
    co2Max: z.number().int().nonnegative().nullable().optional(),
    lightMin: z.number().int().nonnegative().nullable().optional(),
    lightMax: z.number().int().nonnegative().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
export const GrowthQuerySchema = z.object({
    deviceId: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    status: z.enum(['pending', 'confirmed']).optional(),
});
//# sourceMappingURL=growth.js.map